/** PURE_IMPORTS_START ._PromiseObservable PURE_IMPORTS_END */
import { PromiseObservable } from './PromiseObservable';
export var fromPromise = PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/fromPromise.js
// module id = ./node_modules/rxjs/_esm5/observable/fromPromise.js
// module chunks = vendor